import { Button, Flex, Input, useClipboard } from "@chakra-ui/react";
import { FC, useState } from "react";

interface ClipboardProps {
    value: string,
    placeholder?: string
};

const AppClipboard: FC<ClipboardProps> = ({ value, placeholder }) => {
    const { hasCopied, onCopy } = useClipboard(value)

    return (
        <Flex mb={2}>
            <Input value={value} isReadOnly placeholder={placeholder} />
            <Button onClick={onCopy} ml={2}>
                {hasCopied ? 'Tersalin' : 'Salin'}</Button>
        </Flex>);
};

export default AppClipboard;